import { render, staticRenderFns } from "./AcademicRecordsSection.vue?vue&type=template&id=089c099a&"
import script from "./AcademicRecordsSection.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports